/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A web search the agent ran. A search runs a billed completion, so its token spend lives here.
 */
export type ResearchWebSearchCall = {
  /**
   * Completion tokens this search spent.
   */
  completionTokens?: number | undefined;
  /**
   * Prompt tokens this search spent.
   */
  promptTokens?: number | undefined;
  /**
   * What the agent searched for.
   */
  query?: string | undefined;
  /**
   * How many citations the search returned.
   */
  resultCount?: number | undefined;
};

/** @internal */
export const ResearchWebSearchCall$inboundSchema: z.ZodMiniType<
  ResearchWebSearchCall,
  unknown
> = z.pipe(
  z.object({
    completion_tokens: z.optional(z.int()),
    prompt_tokens: z.optional(z.int()),
    query: z.optional(z.string()),
    result_count: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "completion_tokens": "completionTokens",
      "prompt_tokens": "promptTokens",
      "result_count": "resultCount",
    });
  }),
);

export function researchWebSearchCallFromJSON(
  jsonString: string,
): SafeParseResult<ResearchWebSearchCall, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResearchWebSearchCall$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResearchWebSearchCall' from JSON`,
  );
}
